import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ServiceAuthDiscoveryPage = lazy(
  () => import('~/features/service-auth/pages/service-auth-discovery-page'),
);

export const Route = createFileRoute('/_authenticated/_tenant/platform/service-auth/discovery')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ServiceAuthDiscoveryPage />
    </Suspense>
  ),
});
